import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_CLUSTERS_NAMES
} from '../actions/Shutdown3gActions';

const initialState = {
	clustersNames: [],
	formState: {
		values: {
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const shutdown3gReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: []
						};
					}
					case GET_CLUSTERS_NAMES: {
						return {
							...state,
							clustersNames: action.clustersNames
						};
					}
					default: {
						return state;
					}
	}
};

export default shutdown3gReducer;
